var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass:
                  "pt-3 l-m-b-20 align-items-center d-flex justify-content-between blocks"
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("h1", { staticClass: "pr-3 w-full" }, [
                    _vm._v("Claim Types")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group search" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.q,
                          expression: "q"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Search" },
                      domProps: { value: _vm.q },
                      on: {
                        keyup: function($event) {
                          _vm.searchText($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.q = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn input-group-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.clearSearch }
                      },
                      [
                        _c("i", {
                          class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.toggleSidebar }
                    },
                    [_vm._v("\n            ADD CLAIM TYPE\n          ")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            !_vm.claimTypes
              ? [
                  _c(
                    "vue-content-loading",
                    { attrs: { width: 800, height: 450 } },
                    _vm._l(15, function(x) {
                      return _c("rect", {
                        key: x,
                        attrs: {
                          x: "10",
                          y: 15 * x * 1.4,
                          rx: "5",
                          ry: "5",
                          width: "720",
                          height: "6"
                        }
                      })
                    })
                  )
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "blocks" },
                    _vm._l(_vm.claimTypes, function(type, index) {
                      return _c("SettingsClaimTypesBlock", {
                        key: index,
                        attrs: { type: type },
                        on: {
                          "update:type": function($event) {
                            type = $event
                          }
                        }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row blocks" },
                    [
                      _vm.meta.total
                        ? _c(
                            "div",
                            { staticClass: "col-sm-6 mb-1 text-black-50 pl-0" },
                            [
                              _vm._v(
                                "\n            Showing " +
                                  _vm._s(_vm.meta.from) +
                                  " - " +
                                  _vm._s(_vm.meta.to) +
                                  " of " +
                                  _vm._s(_vm.meta.total) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("pagination", {
                        staticClass: "col-sm-6 mb-1 pr-0",
                        attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                      })
                    ],
                    1
                  )
                ]
          ],
          2
        )
      ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showCreateSidebar = false
                  }
                }
              },
              [
                _c("create-claim-type", {
                  staticClass: "sidebar-right",
                  on: {
                    cancel: function($event) {
                      _vm.toggleSidebar()
                    },
                    update: _vm.getAllClaimTypes
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-664bdcb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664bdcb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ClaimTypes/SettingsClaimTypesList.vue
// module id = null
// module chunks = 